module.exports = __webpack_public_path__ + "static/media/health-and-disease-anxiety@2x.1e946207.png";